import { useLocation, useNavigate } from 'react-router-dom';

import { createPeopleGroup, readPeopleGroupPrompts } from '@api/people_groups';
import { Breadcrumbs } from '@utilities';

import Builder from '../../components/Builder';
import Column from '../../layouts/Column';

const CreatePeopleGroup = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return (
    <Column>
      <Breadcrumbs />
      <Builder
        create={createPeopleGroup}
        documentId="people-group"
        onSubmit={() => navigate('/dashboard/workspace/people-groups')}
        read={() => readPeopleGroupPrompts({ search, transform: false })}
        type="People Group"
      />
    </Column>
  );
};

export default CreatePeopleGroup;
